export const DISTRIBUTION = [.0836,.0903,.1019,.1116,.1057,.0953,.0799,.0657,.0551,.2109];
